import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const Gaps = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="gaps" userClaims={userClaims} />
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Cold Chain Gaps Analysis</h1>
          </div>
          
          <div className="w-full" style={{ height: 'calc(100vh - 200px)' }}>
            <PowerBIEmbed
              reportId="ecaf7bc0-baa0-45e5-bd5f-dbe8e8e66afe"
              workspaceId="7d441575-4aa9-4260-99dd-543f002c0340"
              height={800}
          
            />
          </div>
        </div>
      </div>
      
      </div>
  );
};

export default Gaps; 

